import { FC, useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { APPEAL_TYPES } from 'entities/appeal/model'
import { ApplyFormTicket } from 'entities/appeal/ui/form/appeal-form-ticket'
import { FormFeedBack } from 'entities/appeal/ui/form/appeal-form-ticket/appeal-form-ticket'
import { FeedBackBanner } from 'entities/appeal/ui/form/feed-back-form/components/feed-back-banner'

import { AppealApi } from 'shared/api/Appeal.ts'
import {
  AppealsSubjects,
  CreateAppealFormDataRequest,
  KeyValue,
} from 'shared/api/AppealModel.ts'
import { MyTicketItem } from 'shared/api/MyTicketsModel.ts'
import { TYPE_APPELS } from 'shared/constants'
import ErrorImage from 'shared/images/error.png'
import MarkImage from 'shared/images/tick_bold.png'
import { convertFilesToBase64 } from 'shared/lib//convertImageToBase64'
import { getErrorMessage } from 'shared/lib/errorText'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Loader } from 'shared/ui/loader'
import { PopupContent } from 'shared/ui/poup-content'

import styles from './styles.module.scss'

interface Props {
  ticket?: MyTicketItem
}

const Feedback: FC<Props> = ({ ticket }) => {
  const { t } = useTranslation()

  const { appealId } = useParams()

  const { closeDialog, openDialog } = useDialogBottomSheet()

  const [topics, setTopics] = useState<AppealsSubjects>()
  const [loading, setLoading] = useState<boolean>(true)

  const onSubmit = async (formData: FormFeedBack) => {
    setLoading(true)

    let typeTopic: string = ''

    if (String(formData?.topic) === APPEAL_TYPES.TRADE_TICKET_SUBJECTS) {
      typeTopic = TYPE_APPELS.EXCHANGE
    }
    if (String(formData?.topic) === APPEAL_TYPES.REFUND_TICKET_SUBJECTS) {
      typeTopic = TYPE_APPELS.REFUND
    }
    if (String(formData?.topic) === APPEAL_TYPES.OTHER_SUBJECTS) {
      typeTopic = TYPE_APPELS.OTHER
    }

    const selectedTopic: KeyValue[] | [] =
      topics?.[formData?.topic as keyof object] || []

    const subjectSelected = selectedTopic?.filter(
      (topic) => String(topic.key) === formData?.subject,
    )[0]

    const createAppeal: CreateAppealFormDataRequest = {
      contact_phone_number: `${formData?.phone.code}${formData?.phone.phone}`,
      email: formData?.email || '',
      billing_number: ticket?.billing_number || 0,
      subject: subjectSelected?.value,
      avia_topic_id: String(subjectSelected.key),
      details: formData?.description,
      topic: typeTopic,
      appeals_detail: {
        passengers: formData?.passengers?.map((item) => ({
          passenger_key: item.value,
        })),
      },
    }

    if (formData.files?.length) {
      const results = await convertFilesToBase64(formData.files)

      createAppeal.images = results
    }

    try {
      await AppealApi.onCreateAppeal(createAppeal)

      onShowPopUp(true)
    } catch (err) {
      const errorText = getErrorMessage(err)

      onShowPopUp(false, errorText)
    } finally {
      setLoading(false)
    }
  }

  const getAppealTopics = async () => {
    try {
      const { data: AppealsSubjects } = await AppealApi.getAppealsTopics(
        String(appealId),
      )

      setTopics(AppealsSubjects?.data?.[0])
    } finally {
      setLoading(false)
    }
  }

  const onShowPopUp = (isSuccess?: boolean, text?: string) => {
    openDialog({
      child: (
        <PopupContent
          image={isSuccess ? MarkImage : ErrorImage}
          title={isSuccess ? t('success_title') : t('error')}
          description={
            isSuccess
              ? t('feed_back.common_description_after')
              : text || t('please_tey_again')
          }
          button={isSuccess ? t('close') : t('try_again')}
          onClick={closeDialog}
        />
      ),
      isDialog: false,
    })
  }

  useEffect(() => {
    if (appealId) {
      getAppealTopics()
    }
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeaderGoBack buttonWhite />
      </div>

      <div className={styles.form}>
        {loading ? (
          <Loader marginTop={200} />
        ) : (
          <div className={styles.box}>
            <FeedBackBanner />
            <ApplyFormTicket
              topics={topics}
              ticket={ticket}
              onSubmit={onSubmit}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default Feedback
